export default () => {
    const domainElement = document.getElementById('newDomain');
    if (!domainElement) {
        return;
    }

    domainElement.onkeyup = () => {
        const domain = domainElement.value.toLowerCase();

        const helpElement = document.getElementById('domainHelp');

        if (domain.startsWith('www.')) {
            const messageElement = helpElement.getElementsByTagName('span')[0];

            const message = messageElement
                .dataset
                .domainMessage
                .replace('#DOMAIN_NAME_FULL#', domain)
                .replace('#DOMAIN_NAME#', domain.replace('www.', ''));

            messageElement.innerHTML = message;

            helpElement.style.display = 'block';
        } else {
            helpElement.style.display = 'none';
        }

        domainElement.value = domain;
    };

    document.getElementById('removeDomainPrefix').onclick = () => {
        const domain = domainElement.value.replace('www.', '');
        domainElement.value = domain;

        document.getElementById('domainHelp').style.display = 'none';
    };
};
